import { render } from "./Entrynovip.vue?vue&type=template&id=74665880&scoped=true"
import script from "./Entrynovip.vue?vue&type=script&lang=js"
export * from "./Entrynovip.vue?vue&type=script&lang=js"

import "./Entrynovip.vue?vue&type=style&index=0&id=74665880&scoped=scoped&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74665880"]])

export default __exports__